// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"7b5069d2","378":"bbf33c11","596":"e16ca1a3"}[chunkId] + ".chunk.js";
};